import { render, staticRenderFns } from "./DeleteArticleImport.vue?vue&type=template&id=6a4f5323"
import script from "./DeleteArticleImport.vue?vue&type=script&lang=js"
export * from "./DeleteArticleImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports